import React from 'react';

type CabTravellingForProps = {
  travelForVal: string;
  closeTravelForPopup: () => void;
  travelFor: (string) => void;
  labelText?: string;
  isRydeHomePage?: boolean;
};
const CabTravellingFor = React.memo(
  ({
    travelForVal,
    closeTravelForPopup,
    travelFor,
    labelText,
    isRydeHomePage = false
  }: CabTravellingForProps) => {
    return (
      <div className={`travelForPopup cabTravellingForCont`}>
        <p className="travelForPopup--header">
          <span className="font18 latoBold blackText">
            {labelText ? labelText : 'Select Trip Type'}
          </span>
          <span className="close" onClick={() => closeTravelForPopup()}></span>
        </p>
        <ul className="blackText">
          <React.Fragment>
            <li
              className={`truncate ${
                travelForVal === 'Outstation One-way' ? 'deepskyBlueText' : ''
              }`}
              onClick={() => {
                travelFor('Outstation One-way');
              }}
            >
              <p className="font14 latoSemiBold appendBottom2">
                Outstation One-way
              </p>
              <p className="font11">Drop off that includes one lunch stop</p>
            </li>
            <li
              className={`truncate ${
                travelForVal === 'Outstation Round-trip'
                  ? 'deepskyBlueText'
                  : ''
              }`}
              onClick={() => {
                travelFor('Outstation Round-trip');
              }}
            >
              <p className="font14 latoSemiBold appendBottom2">
                Outstation Round-trip
              </p>
              <p className="font11">Return trip that includes mutiple stops</p>
            </li>
            <li
              className={`truncate ${
                travelForVal === 'Cab From Airport' ? 'deepskyBlueText' : ''
              }`}
              onClick={() => {
                travelFor('Cab From Airport');
              }}
            >
              <p className="font14 latoSemiBold appendBottom2">
                Cab From Airport
              </p>
              <p className="font11">Pre-book airport pick up</p>
            </li>
            <li
              className={`truncate ${
                travelForVal === 'Cab To Airport' ? 'deepskyBlueText' : ''
              }`}
              onClick={() => {
                travelFor('Cab To Airport');
              }}
            >
              <p className="font14 latoSemiBold appendBottom2">
                Cab To Airport
              </p>
              <p className="font11">Pre-book airport drop</p>
            </li>{' '}
            {
              <li
                className={`truncate ${
                  travelForVal === 'Rentals' ? 'deepskyBlueText' : ''
                }`}
                onClick={() => {
                  travelFor('Rentals');
                }}
              >
                <p className="font14 latoSemiBold appendBottom2">Rentals</p>
                <p className="font11">Car rental within the city</p>
              </li>
            }
          </React.Fragment>
        </ul>
      </div>
    );
  }
);

export default CabTravellingFor;
